import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Invoice } from '../rechnung';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../../../src/app/components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-rechnung-storno-dialog',
    templateUrl: './rechnung-storno-dialog.component.html',
    styleUrls: ['./rechnung-storno-dialog.component.css'],
})
export class RechnungStornoDialogComponent implements OnInit {
    invoice: Invoice = new Invoice();

    gutschriftDatumCtrl = new UntypedFormControl(new Date(), [Validators.required]);

    constructor(
        public dialogRef: MatDialogRef<RechnungStornoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private tableService: KieneTableService,
        private messageService: MessageService,
    ) {
        this.invoice = this.data.invoice;
    }

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }

    save() {
        this.invoice.status_id = 55;
        this.invoice.gutschrift_datum = this.gutschriftDatumCtrl.value;
        this.tableService.updateGeneric(this.apiBaseUrl + 'rechnung/stornieren.php', this.invoice).subscribe({
            next: (response: Invoice) => {
                this.dialogRef.close(response);
            },
            error: err => {
                this.messageService.errorMessage('Rechnung konnte nicht storniert werden!', err);
            },
        });
    }
}
